import request from '@/utils/request';
import Resource from '@/api/resource';

class MaterialResource extends Resource {
  constructor() {
    super('material/jrtt');
  }

  // 上传图片素材
  uploadingPicApi(data) {
    return request({
      url: `${this.uri}/addImage`,
      method: 'POST',
      data,
      headers: {
        'Content-Type':	'multipart/form-data; charset=UTF-8',
      },
    });
  }

  // 获取视频智能封面库接口
  getVideoCoverApi(data) {
    return request({
      url: `${this.uri}/getVideoCover`,
      method: 'get',
      params: data,
    });
  }

  // 获取广告创意视频预览地址接口
  getVideoPreUrlApi(data) {
    return request({
      url: `${this.uri}/getVideoPreUrl`,
      method: 'get',
      params: data,
    });
  }
}

export { MaterialResource as default };
